import { camelizeKeys } from 'humps';
import { POLICY_TYPES } from './constants/policies';
import type { IError } from './types/common';
import { captureExceptionWithRecording } from './utils';

export function processKeys(data: object) {
  return camelizeKeys(data, (key: any, convert: any, options: any) => {
    if (
      POLICY_TYPES.includes(key) ||
      ['_non_field_errors', '_error'].includes(key) ||
      key.includes('sectionFields') ||
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(key)
    )
      return key;
    return convert(key, options);
  }) as unknown as any;
}

export function getAPIHost({ version = 'v1' }: { version?: 'v1' | 'v2' } = {}) {
  const addVersion = (url: string) => `${url}/${version}`;
  return addVersion('/api');
}

export function getNestAPIHost({
  version = 'v1',
}: {
  version?: 'v1' | 'v2';
} = {}) {
  const addVersion = (url: string) => `${url}/${version}`;

  return addVersion('/router/api-xc-eu_central_1');
}

function captureError(error: IError, url?: string) {
  captureExceptionWithRecording(error, {
    error: JSON.stringify(error),
    url,
  });
}

export const createError = ({
  status,
  response,
  url,
  requestId,
}: {
  status?: number | string;
  response?: any;
  url?: string;
  requestId?: string | null;
}) => {
  const error: IError = new Error(response?.message);

  error.status = status;
  if (response?.type) {
    error.name = response.type;
  }
  if (response?.errors) {
    error.errors = response.errors;
  }
  if (response?.code) {
    error.code = response.code;
  }
  if (requestId) {
    error.requestId = requestId;
  }
  captureError(error, url);
};
